module.exports = __webpack_public_path__ + "img/Perks-40.031df55d.png";